import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { getKnowledgeBaseUrl } from 'ui-addon-i18n/internal/utils/getLangCodeSpecificUrls';
import { TrackedLink } from '../../../utils/UsageTracking/TrackedLink';
import { KNOWLEDGE_BASE_URLS } from '../../../shared/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_MESSAGE_KEY = 'global.learnMore';
export const LearnMoreLink = ({
  usageTracker,
  componentName,
  screen,
  subscreen,
  dataTestId,
  use,
  external = true,
  messageKey = DEFAULT_MESSAGE_KEY,
  featureUrl
}) => {
  const localizedUrl = getKnowledgeBaseUrl(featureUrl || KNOWLEDGE_BASE_URLS.CREDITS);
  if (usageTracker && componentName && screen) {
    return /*#__PURE__*/_jsx(TrackedLink, {
      "data-test-id": dataTestId,
      href: localizedUrl,
      usageTracker: usageTracker,
      componentName: componentName,
      screen: screen,
      subscreen: subscreen,
      use: use,
      external: external,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: messageKey
      })
    });
  }
  return /*#__PURE__*/_jsx(Link, {
    href: localizedUrl,
    use: use,
    "data-test-id": dataTestId,
    external: external,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: messageKey
    })
  });
};